import { useQuery } from '@tanstack/react-query';
import type { ICareHomeListResponse } from '../../interfaces';
import { STALE_TIME_LIST_MS } from '../../constants/reactQueryStaleTime.ts';
import CareHomeService from '../../services/CareHomeService.ts';

export type CareHomeListQueryInput = {
  organisationId?: string;
  page: number;
  perPage: number;
  query: string;
  isActive: boolean;
  orderBy: string;
  sortOrder: 'asc' | 'desc';
};

export const getCareHomesListQueryKey = (input: CareHomeListQueryInput) =>
  [
    'careHomes',
    input.organisationId,
    input.page,
    input.perPage,
    input.query,
    input.isActive,
    input.orderBy,
    input.sortOrder,
  ] as const;

export function useCareHomesListQuery(input: CareHomeListQueryInput, enabled: boolean) {
  return useQuery<ICareHomeListResponse>({
    queryKey: getCareHomesListQueryKey(input),
    enabled: enabled && !!input.organisationId,
    staleTime: STALE_TIME_LIST_MS,
    queryFn: () =>
      CareHomeService.getCareHomes({
        organisation_id: input.organisationId!,
        page: input.page,
        per_page: input.perPage,
        query: input.query || undefined,
        is_active: input.isActive,
        order_by: input.orderBy,
        sort_order: input.sortOrder,
      }),
  });
}

